import { Tag } from "@carbon/react";
import { FC } from "react";

import { useFormatDate, useT } from "src/internationalization";

export type CaseArchivedTagProps = {
  date: Date;
};

export const CaseArchivedTag: FC<CaseArchivedTagProps> = ({ date }) => {
  const t = useT();
  const formatDate = useFormatDate();

  return (
    <Tag type="gray">
      {t("case.archived.tag.label", {
        date: formatDate(date, {
          dateStyle: "medium",
          timeStyle: "short",
        }),
      })}
    </Tag>
  );
};
